import { Component, Injector, OnInit } from "@angular/core";
import { GenericComponent } from "../../components/generic.component";
import { MatDialogRef } from "@angular/material/dialog";
import { MessageBeforeManuallyAddPartActionsEnum } from "../../enums/message-before-manually-add-part-actions.enum";

@Component({
    selector: "app-smartfleet-budget-part-item-form-modal",
    templateUrl: "./message-before-manually-add-part-modal.component.html",
    styleUrls: ["./message-before-manually-add-part-modal.component.scss"],
    standalone: false
})
export class MessageBeforeManuallyAddPartModalComponent
  extends GenericComponent
  implements OnInit
{
  constructor(
    injector: Injector,
    private matDialogRef: MatDialogRef<MessageBeforeManuallyAddPartModalComponent>
  ) {
    super(injector);
  }

  actionsEnum: string[];

  ngOnInit() {}

  callUseExistingPart() {
    this.closeDialog(MessageBeforeManuallyAddPartActionsEnum.USE_EXISTING_PART);
  }

  callCreatePart() {
    this.closeDialog(MessageBeforeManuallyAddPartActionsEnum.CREATE_PART);
  }

  callCloseDialog() {
    this.closeDialog(null);
  }

  closeDialog(action: MessageBeforeManuallyAddPartActionsEnum): void {
    this.matDialogRef.close(action);
  }
}
